"use client"
import React, { useState, useEffect } from "react"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Cookies from "js-cookie"
import { checkBannerCookie, setBannerCookie } from "./PromotionBannerMethods"
import  { PromotionBanner } from "trimble-terra"
import useCheckOneTrust from "./useCheckOneTrust"
import { processLinkUrl } from '@/utils/linkUtils';

const PromotionBannerConnector = ({ promotionBanner }) => {
  const {
    redisplayDays,
    header,
    richTextDetails,
    cookieName
  } = promotionBanner
  const updatedAt = promotionBanner?.sys?.publishedAt || null
  // Region: State and cookies
  const [hasDismissedBanner, setHasDismissedBanner] = useState(true)
  const { hasAcceptedOneTrust } = useCheckOneTrust(Cookies)

  const bannerLink = promotionBanner?.linkCollection?.items?.[0]

  useEffect(() => {
    // check if promo banner is linked to a specific page or pages, and only display on those pages
    if(typeof window !== "undefined"){
      if (checkBannerCookie(Cookies, cookieName, updatedAt)) {
        // if cookie exists, banner has been dismissed previously
        setHasDismissedBanner(true)
      } else {
        setHasDismissedBanner(false)
      }
    }
  }, [setHasDismissedBanner, updatedAt, cookieName])

  const handleDismiss = () => {
    //When the user dismisses the overlay, set a cookie ...
    //so that we can check if the user has dismissed the overlay on future visits
    setBannerCookie(Cookies, cookieName, updatedAt, redisplayDays)
    setHasDismissedBanner(true)
  }

  const promotionLink = {
      destination: processLinkUrl(bannerLink?.destination ? bannerLink : bannerLink),
      label: bannerLink?.textLabel,
      type: "link",
    }

  const formattedDetails = documentToReactComponents(richTextDetails?.json);

  return (
    <PromotionBanner
      header={header}
      cta={promotionLink}
      details={formattedDetails}
      handleClose={handleDismiss}
      hasAcceptedOneTrust={hasAcceptedOneTrust}
      hasDismissedBanner={hasDismissedBanner}
    />
  )
}

export default PromotionBannerConnector
